import { takeEvery } from 'redux-saga/effects';

import completeEnrollment from './completeEnrollment';
import actions from '../../actions';

export default function* applicationFlow() {
  yield takeEvery(actions.enrollment.completeEnrollment, completeEnrollment);
}
